<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="tab_modules"
      createButtonText="新建主题"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class Tabmodules extends Vue {

  pagination = {}

  filter = [
    {
      prop: 'name_cont',
      label: '主题名称',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'key_cont',
      label: '唯一标识',
      form: {
        component: 'search'
      }
    }
  ]

  table = {
    data: []
  };

  get columns() {
    return [
      ...createColumns(),
      {
        prop: 'action',
        label: '操作',
        fixed: 'right',
        width: 150,
        detail: true,
        edit: true
      }
    ];
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/tab_modules', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
